<template>
    <div>

        <config-main-title>
            Grupos de Chat
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Grupo de Chat
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum Grupo de Chat identificado.'" 
                icon="fa-solid fa-users"
                :action="'Incluir Grupo de Chat'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                        <span class="badge badge-secondary mr-2">
                            #{{ dado.id_chat_sala }}
                        </span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" :id="'ativo-' + id" v-model="dado.fl_ativo" @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div class="d-flex" v-else>
                            <span class="badge badge-secondary" title="Quantidade de membros.">{{ dado.membros_count }}</span>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_chat_sala ? '' : 'Nova' }}
                            Grupo de Chat
                            <span class="badge badge-secondary ml-2" v-if="item.id_chat_sala">
                                #{{ item.id_chat_sala }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">

                        <div class="mb-3">
                            <az-input
                                label="Título do Grupo"
                                type="text"
                                placeholder="Informe o nome do grupo..."
                                v-model="item.st_titulo" 
                                required
                                :validate="validate">
                                <template v-slot:buttonposb>
                                    <div class="input-group-append">
                                        <div class="input-group-text" title="Quantidade de membros ativos.">{{ lista_grupo_membros.length }}</div>
                                    </div>
                                </template>
                            </az-input>
                        </div>

                        <az-input
                            placeholder="Informe o usuário para inclusão no grupo..."
                            icon="fas fa-plus"
                            type="autocomplete" 
                            optionsMode="aql"
                            service="usuarios.index"
                            :optionsParm="{ chat: true }"
                            v-model="novo_usuario_grupo"
                            ref="info_usuario_grupo"
                            :edicao="lista_grupo_membros.length < 50"
                            @input="incluirUsuarioGrupo()" />

                        <div class="alert alert-secondary mb-1" v-if="lista_grupo_membros.length >= 50">
                            Limite de 50 membros ativos por grupo atingido.
                        </div>

                        <ul class="list-group" v-if="lista_grupo_membros.length > 0">
                            <li class="list-group-item d-flex justify-content-between" v-for="(membro, imx) in lista_grupo_membros" :key="imx">
                                <div>
                                    <a href="#" class="text-danger mr-3" @click.prevent="remover_grupo_membro(membro)">
                                        <i class="fas fa-times"></i>
                                    </a>
                                    {{ membro.usuario.pessoa.st_nome }}
                                    <span class="small ml-2 text-muted">{{ membro.usuario.st_login }}</span>
                                </div>
                                <div>
                                    <az-input
                                        sizing="sm"
                                        label="Silenciado"
                                        type="checkbox-group"
                                        :optionsList="[
                                            { id: true, search: 'Silenciado' }, 
                                            { id: false, search: 'Ativo' }, 
                                        ]"
                                        optionsData="id"
                                        v-model="membro.fl_zzz">
                                    </az-input>
                                </div>
                            </li>
                        </ul>

                        <az-empty-state 
                            v-else 
                            msg="Nenhuma usuário no grupo." 
                            icon="fa-solid fa-users-line" />

                        <br><br><br><br><br><br><br><br><br><br>

                        <pre v-if="1==0">{{ item }}</pre>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="chatSala" :id="item.id_chat_sala" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_chat_sala ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
// import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            filtro: { 
                periodo: 'm', 
            },
            edicao_datas: null, 
            edicao_data: null,
            novo_usuario_grupo: "", 
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
    },

    computed: { 
        lista_grupo_membros: function () {
            if ( !this.item || !this.item.membros )
                return [];

            return this.item.membros.filter(item => item.fl_ativo);
        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            if ( this.edicao_datas ) {
                return [ 
                    this.edicao_datas, 
                ];
            }

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

    },

    methods: { 
        incluirUsuarioGrupo () { 

            if ( !this.novo_usuario_grupo )
                return;

            if ( this.item.membros.find(item => item.id_usuario == this.novo_usuario_grupo.id_usuario) ) { 
                this.$toast.add({ 
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Usuário já está no grupo.'
                });
            } else { 
                this.item.membros.push({ 
                    id_usuario: this.novo_usuario_grupo.id_usuario, 
                    usuario: this.novo_usuario_grupo,
                    fl_ativo: true 
                });
            }

            this.novo_usuario_grupo = null;

            this.$nextTick(() => {
                this.novo_usuario_grupo = "";
            });

        },

        remover_grupo_membro (membro) { 
            if ( !confirm("Confirma remover '" + membro.usuario.pessoa.st_nome + "' do grupo?'") ) { 
                return; 
            }

            membro.fl_ativo = false; 
        },

        incluir_procedimento () { 
            this.item.items.push({
                id_procedimento: null,
                procedimento: "", 
                excluido: false, 
            });
        },

        
        clonar() { 
            if ( !confirm ("Confirma clonar o item '" + this.item.st_titulo + "'?") )
                return;

            this.$util.atualizar(this, { 
                service: 'cadastros',
                func: 'clonar',
                dados: { 
                    model: 'ofertaParticular',
                    id: this.item.id_oferta_particular,
                },
                modal: 'edicaoModal',
                toast: true, 
                reload: true, 
            });
        },

        incluir_filtro(item) { 
            item.filtros.push({ 
                origem_type: 'App\\azure\\ofertaParticular',
                origem_id: this.item.id_oferta_particular,
                model_type: "",
                model_id: "",
                model: "", 
                service: "", 
                fl_regra: true, 
                excluido: false, 
            });
        },

        incluir () { 
            this.validate = false;
            this.item = null; 

            this.$nextTick(() => { 
                this.item = {
                    id_chat_sala: null, 
                    fl_ativo: true, 
                    st_titulo: "", 
                    st_tipo: 'P2G', 
                    membros: [], 
                };

                $('#edicaoModal').modal('show');
            }); 
        },
        load () { 
            this.$util.load(this, { 
                service:'chat_salas',
                func: 'index',
                parms: { 
                    cadastro: true,
                    grupo: true,  
                },
            });
        },
        editar (item) { 
            this.item = null; 
            this.validate = false; 

            this.$nextTick(() => { 

                this.$util.load(this, { 
                    service:'chat_salas',
                    func: 'show',
                    parms: { 
                        id: item.id_chat_sala,
                        cadastro: true, 
                        edicao: true, 
                    },
                    loadTo: res => { 
                        this.item = res; 
                        $('#edicaoModal').modal('show');    
                    }
                });

            });
        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'chat_salas',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },

        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'chat_salas',
                dados: item,
            });

        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Ofertas Particulares", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }

}
</script>